import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import rotate from "@xo-union/util-rotate-number";
import React from "react";
const bindDispatch = function (dispatch, actionCreator) {
  for (var _len = arguments.length, curry = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    curry[_key - 2] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    dispatch(actionCreator(...curry, ...params));
  };
};
const staticInitialState = {
  isOpen: false,
  lastActiveIndex: 0,
  activeIndex: 0,
  options: []
};
const actions = {
  types: {
    ROTATE_ACTIVE_INDEX: 'ROTATE_ACTIVE_INDEX',
    ACTIVATE_OPTION_MATCHING_TEXT: 'ACTIVATE_OPTION_MATCHING_TEXT',
    ADD_OPTION: 'ADD_OPTION',
    REMOVE_OPTION: 'REMOVE_OPTION',
    UPDATE_SELECTED_VALUE: 'UPDATE_SELECTED_VALUE',
    UPDATE_OPEN_VALUE: 'UPDATE_OPEN_VALUE'
  },
  rotateActiveIndex: offset => ({
    type: actions.types.ROTATE_ACTIVE_INDEX,
    payload: {
      offset
    }
  }),
  activateOptionMatchingText: text => ({
    type: actions.types.ACTIVATE_OPTION_MATCHING_TEXT,
    payload: {
      text
    }
  }),
  addOption: option => ({
    type: actions.types.ADD_OPTION,
    payload: {
      option
    }
  }),
  removeOption: optionID => ({
    type: actions.types.REMOVE_OPTION,
    payload: {
      optionID
    }
  }),
  updateSelectedValue: newValue => ({
    type: actions.types.UPDATE_SELECTED_VALUE,
    payload: {
      newValue
    }
  }),
  updateOpenValue: newValue => ({
    type: actions.types.UPDATE_OPEN_VALUE,
    payload: {
      newValue
    }
  })
};
const getWordsFromRef = ref => {
  var _ref$current, _ref$current$textCont, _ref$current$textCont2, _ref$current$textCont3;
  return ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$textCont = _ref$current.textContent) === null || _ref$current$textCont === void 0 ? void 0 : (_ref$current$textCont2 = _ref$current$textCont.toLowerCase()) === null || _ref$current$textCont2 === void 0 ? void 0 : (_ref$current$textCont3 = _ref$current$textCont2.replace(/[^\w\s]+/g, '')) === null || _ref$current$textCont3 === void 0 ? void 0 : _ref$current$textCont3.split(/\s+/g)) || [];
};
const findIndexOfOptionMatchingText = (options, text, fallback) => {
  var _context;
  const optionsTextsSortedByLeastWords = _sortInstanceProperty(_context = _mapInstanceProperty(options).call(options, (_ref, originalIndex) => {
    let {
      ref
    } = _ref;
    return {
      words: getWordsFromRef(ref),
      index: originalIndex
    };
  })).call(_context, (_ref2, _ref3) => {
    let {
      words: a
    } = _ref2;
    let {
      words: b
    } = _ref3;
    return a.length - b.length;
  });
  const result = _findInstanceProperty(optionsTextsSortedByLeastWords).call(optionsTextsSortedByLeastWords, _ref4 => {
    let {
      words
    } = _ref4;
    return _someInstanceProperty(words).call(words, word => _startsWithInstanceProperty(word).call(word, text.toLowerCase()));
  });
  return result === undefined ? fallback : result.index;
};
const reducer = (state, action) => {
  switch (action.type) {
    case actions.types.OPEN:
      return {
        ...state,
        isOpen: true,
        lastActiveIndex: state.activeIndex
      };
    case actions.types.CLOSE:
      return {
        ...state,
        isOpen: false,
        activeIndex: state.lastActiveIndex
      };
    case actions.types.ROTATE_ACTIVE_INDEX:
      return {
        ...state,
        activeIndex: rotate(state.activeIndex, action.payload.offset, state.options.length)
      };
    case actions.types.ACTIVATE_OPTION_MATCHING_TEXT:
      return {
        ...state,
        activeIndex: findIndexOfOptionMatchingText(state.options, action.payload.text, state.activeIndex)
      };
    case actions.types.ADD_OPTION:
      {
        let newActiveIndex = state.activeIndex;
        if (action.payload.option.value === state.value) {
          /*
           * If registered option has the selected value
           * adjust the active index
           * */
          newActiveIndex = state.options.length;
        }
        return {
          ...state,
          activeIndex: newActiveIndex,
          lastActiveIndex: newActiveIndex,
          options: [...state.options, action.payload.option]
        };
      }
    case actions.types.REMOVE_OPTION:
      {
        var _context2;
        const newOptions = _filterInstanceProperty(_context2 = state.options).call(_context2, _ref5 => {
          let {
            id
          } = _ref5;
          return id !== action.payload.optionID;
        });
        const valueIsPresent = _someInstanceProperty(newOptions).call(newOptions, option => option.value === state.value);
        return {
          ...state,
          activeIndex: valueIsPresent ? state.activeIndex : 0,
          lastActiveIndex: valueIsPresent ? state.lastActiveIndex : 0,
          options: newOptions
        };
      }
    case actions.types.UPDATE_SELECTED_VALUE:
      {
        var _context3;
        const value = action.payload.newValue;
        let newActiveIndex = _findIndexInstanceProperty(_context3 = state.options).call(_context3, option => value === option.value);

        /**
         * If no option matches the current value, reset the index to 0
         * */
        if (newActiveIndex === -1) {
          newActiveIndex = 0;
        }
        return {
          ...state,
          activeIndex: state.isOpen ? state.activeIndex : newActiveIndex,
          lastActiveIndex: newActiveIndex,
          value
        };
      }
    case actions.types.UPDATE_OPEN_VALUE:
      {
        const newOpenValue = action.payload.newValue;
        const nextActiveIndex = newOpenValue ? state.activeIndex : state.lastActiveIndex;
        return {
          ...state,
          isOpen: newOpenValue,
          activeIndex: nextActiveIndex,
          lastActiveIndex: nextActiveIndex
        };
      }
    default:
      {
        throw new Error(`Unxpected action type: ${action.type}`);
      }
  }
};
const useSelect = _ref6 => {
  let {
    isOpen,
    onOpen,
    onClose,
    value,
    defaultValue,
    disabled,
    onChange
  } = _ref6;
  const {
    current: isControlled
  } = React.useRef(typeof value !== 'undefined');
  const {
    current: openIsControlled
  } = React.useRef(typeof isOpen !== 'undefined');
  const initialState = {
    ...staticInitialState,
    value: (isControlled ? value : defaultValue) || ''
  };
  const [state, dispatch] = React.useReducer(reducer, initialState);
  if (value !== state.value && isControlled) {
    dispatch(actions.updateSelectedValue(value));
  }
  if (isOpen !== state.isOpen && openIsControlled) {
    dispatch(actions.updateOpenValue(isOpen));
  }
  return React.useMemo(() => {
    var _context4;
    const dispatchClose = bindDispatch(dispatch, actions.updateOpenValue, false);
    const dispatchOpen = bindDispatch(dispatch, actions.updateOpenValue, true);
    const close = () => {
      if (openIsControlled) {
        onClose();
      } else {
        dispatchClose();
      }
    };
    const open = () => {
      if (openIsControlled) {
        onOpen();
      } else {
        dispatchOpen();
      }
    };
    const toggle = () => {
      if (state.isOpen) {
        close();
      } else {
        open();
      }
    };
    const updateSelectedValue = bindDispatch(dispatch, actions.updateSelectedValue);
    const selectedOption = _findInstanceProperty(_context4 = state.options).call(_context4, option => option.value === state.value);
    const emitChangeAndClose = evt => {
      onChange(evt);
      if (!isControlled) {
        updateSelectedValue(evt.target.value);
      }
      close();
    };
    return {
      disabled: !!disabled,
      onChange: emitChangeAndClose,
      options: state.options,
      value: state.value,
      isOpen: !disabled && state.isOpen,
      hasFocusedOption: !!(state.isOpen || selectedOption),
      activeOption: state.options[state.activeIndex],
      selectedOption,
      close,
      addOption: bindDispatch(dispatch, actions.addOption),
      removeOption: bindDispatch(dispatch, actions.removeOption),
      rotateActiveIndex: bindDispatch(dispatch, actions.rotateActiveIndex),
      activateOptionMatchingText: bindDispatch(dispatch, actions.activateOptionMatchingText),
      toggle,
      open,
      isControlled
    };
  }, [state, dispatch, disabled, onChange]);
};
export default useSelect;